// @flow

export const MESSAGES_LIMIT_PER_REQUEST = 20
export const POLLING_PERIOD = 3000
export const STICKY_DISTANCE = 75
export const AUTOSCROLL_TO_LATEST_MAX_DISTANCE = 1000
